module.exports = __webpack_public_path__ + "img/38_86.d16ce1a0.png";